{
    "IncludeendedonholdLabel": "As chamadas terminadas em espera são abandonadas",
    "UnreturnedCalls_SectionHeader": "Chamadas não devolvidas",
    "UnreturnedCalls_SectionPara": "Pode escolher se alguns tipos de chamadas são considerados abandonados nos relatórios \"Chamadas perdidas não devolvidas\", bem como na estatística \"Chamadas não devolvidas\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "As chamadas terminadas por fuga são abandonadas"
}